import { Component, Vue } from 'vue-property-decorator'
import { menuBtn } from '@/utils/menu_level2_button'
import { formatDate } from '@/utils/timeFilter'
import { getMessageReviewById, setMessageReviewUserByMessageReviewId } from '@/api/message'
import { setFinanceOrderStatus, getProjectList } from '@/api/financial-center'
import { Loading } from 'element-ui'
// import { get } from '@/api/financial-center'
import * as math from 'mathjs'

@Component({})
export default class OrderInfo extends Vue {
    priceSum: number = null //订单金额合计
    infoData: any = {}
    reviewId: number;
    logShow = true
    withdrawalDialogShow = false // 撤回审批弹框
    reviewIdea = '' // 审批意见
    reviewDialogShow = false // 审批意见弹框
    status: string
    approvalStatus: number = null
    type = ''
    editFileList: { file: string; cnFile: string; isRequired: string }[] = []
    editFiles = {
        projectAllId: null,
        souCoursePrice: null,
        discountPrice: null,
        price: null,
        haveIPQ: null,
        remark: null,
        priceOrRatio: null,
        isCredit: null,
        dissertationType: null,
        contractNo: null,
    }

    projectDialogShow = false
    projectDialogTableLoading = false
    dialogProjectInputValue = ''
    dialogProjectPage = 1
    dialogProjectLimit = 20
    projectDialogTableData = []
    projectDialogCheckedTable = {
        flag: false,
        projectAllId: NaN,
        souCourseIndex: "",
        souCourseName: "",
        souCoursePrice: "",
        souCourseSchoolBegin: "",
        souCourseType: "",
        status: "",
        surplusQuota: NaN
    }
    dialogProjectTotal = 0
    customerInfo = {
        customerId: undefined,
        customerName: '',
        customerSource: '',
        customerSourceType: '',
        customerType: '',
        marketCooperationId: undefined
    }
    isRequired = false
    editFileRequired = false
    disBtn = false
    cooperationUserRealName = ''
    types = '' // 审批提交还是抄送类型
    addSignShow = false
    transferShow = false
    approvalVisible = false
    stepNode = {
        isFirstNode: false,
        isSyncEkuaibao: false,
        isSyncEqianbao: false,
    }
    nodeType: string = null //驳回到哪个节点
    isSync: string = null //重新提交后触发E签宝/易快报
    approvedVisible = false // 审批通过
    approvedData = {
        isReturn: 1
    }
    isAgreeRevoke = '' // 审批通过是否允许提交人撤回
    loading = false
    isNotReject = false

    created() {
        this.reviewId = Number(this.$route.query.id)
        this.type = this.$route.query.type ? this.$route.query.type as string : ''
        this.types = this.$route.query.types ? this.$route.query.types as string : ''
        this.status = this.$route.query.status as string
        this.getData()
    }

    menuBtn = menuBtn
    formatDate = formatDate

    async getData() {
        this.loading = true
        await getMessageReviewById(this.reviewId, this.types).then((data: any) => {
            this.infoData = data.result
            this.isNotReject = data.result.isNotReject == true ? false : true
            this.cooperationUserRealName = this.infoData.financeOrderUser.cooperationUserRealName
            this.priceSum = this.infoData.price  //订单金额合计
            this.editFileList = this.infoData.editFileList || []
            this.editFileList.forEach(item => {
                this.editFiles[item.file] = this.infoData[item.file]
            })
            if (this.editFileList && this.editFileList.length > 0) this.isRequired = this.type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填

            this.stepNode.isFirstNode = this.infoData.isFirstNode
            this.stepNode.isSyncEkuaibao = this.infoData.isSyncEkuaibao
            this.stepNode.isSyncEqianbao = this.infoData.isSyncEqianbao
            this.loading = false
        }).catch(err => {
            this.loading = false
        })

    }

    // 验证当前字段是否可以编辑
    editFileShow(key: string) {
        if (this.status !== '0' || this.type !== '0') return false
        return this.editFileList.some(item => item.file === key)
    }

    projectInputFocus() {
        this.projectDialogShow = true
        this.getProjectList();
        (this.$refs.projectInput as HTMLFormElement).blur()
    }

    async getProjectList() {
        this.projectDialogTableLoading = true
        const data: any = await getProjectList({
            marketCooperationId: this.infoData.marketCooperationId,
            name: this.dialogProjectInputValue,
            page: this.dialogProjectPage,
            limit: this.dialogProjectLimit
        })
        this.projectDialogTableData = data.projectList
        this.dialogProjectTotal = data.allNum
        this.projectDialogTableLoading = false
    }

    projectPageChange(page: number) {
        this.dialogProjectPage = page
        this.getProjectList()
    }

    clickProjectDialogConfirmButton() {
        this.editFiles.projectAllId = this.projectDialogCheckedTable.projectAllId
        this.infoData.souCourseName = this.projectDialogCheckedTable.souCourseName
        this.editFiles.souCoursePrice = this.projectDialogCheckedTable.souCoursePrice
        this.editFiles.price = this.editFiles.souCoursePrice - this.editFiles.discountPrice
        this.projectDialogShow = false
    }

    dialogProjectTableCheckedChange(selection) {
        if (selection.length > 0) {
            this.projectDialogCheckedTable = JSON.parse(JSON.stringify(selection[0]))
            const dom = this.$refs.dialogProjectTable as HTMLFormElement
            if (selection.length > 1) {
                dom.clearSelection();
                dom.toggleRowSelection(selection.pop());
            }
            // if (this.projectDialogCheckedTable) {
            //     this.formModel.project = this.projectDialogCheckedTable.souCourseName
            // }
        } else {
            for (const key in this.projectDialogCheckedTable) {
                this.projectDialogCheckedTable[key] = null
            }
            // this.formModel.project = ''
        }
    }

    discountPriceChange() {
        /*限制只能输入数字和一位小数点*/
        if (this.editFiles.discountPrice && !/^[0-9.]*$/.test(this.editFiles.discountPrice)) {
            this.$message.error('请输入数字')
            this.editFiles.discountPrice = ''
            return
        }
        if (Number(this.editFiles.discountPrice) > Number(this.infoData.souCoursePrice)) {
            this.$message.error('优惠金额不能大于项目终端售价')
            this.editFiles.discountPrice = ''
            return
        }
        this.priceSum = math.number(math.subtract(math.bignumber(Number(this.infoData.souCoursePrice)), math.bignumber(Number(this.editFiles.discountPrice))))
        //项目终端售价-优惠金额 订单金额合计
        // this.editFiles.price = this.editFiles.souCoursePrice - this.editFiles.discountPrice //订单金额合计

        //  如果是结算价
        if (this.infoData.commissionType === '1') {
            this.priceSum = math.number(math.subtract(math.bignumber(Number(this.infoData.priceOrRatio)), math.bignumber(Number(this.editFiles.discountPrice))))
            //订单金额合计
            //     如果结算价也是可编辑的
            if (this.editFiles.priceOrRatio) {
                this.priceSum = math.number(math.subtract(math.bignumber(Number(this.editFiles.priceOrRatio)), math.bignumber(Number(this.editFiles.discountPrice))))
            }
        }
    }

    dialogProjectRowClick(row) {
        if (!row.flag) return
        (this.$refs.dialogProjectTable as HTMLFormElement).toggleRowSelection(row)
    }

    selectable(row) {
        return row.flag
    }

    // 撤回审批
    async cancelApproval() {
        await setFinanceOrderStatus({ id: this.infoData.id, action: '1' })
        this.$message.success('撤销审批成功')
        setTimeout(() => {
            window.close()
        }, 1500);
        this.withdrawalDialogShow = false
    }

    // 驳回审批
    clickRejectButton(status: number) {
        this.$set(this.stepNode, 'status', status)
        this.$set(this.stepNode, 'approveId', this.reviewId)
        this.approvalVisible = true
    }
    //通过审批
    clickExamineApproveButton(status: number) {
        this.editFiles.price = this.priceSum
        this.$set(this.approvedData, 'status', status)
        this.$set(this.approvedData, 'editFiles', this.editFiles)
        this.$set(this.approvedData, 'editFileList', this.editFileList)
        this.$set(this.approvedData, 'isRequired', this.isRequired)
        this.$set(this.approvedData, 'approveId', this.reviewId)
        this.approvedVisible = true
    }

    // 关闭审批意见弹框
    closeReviewDialog() {
        this.reviewIdea = ''
        this.reviewDialogShow = false
    }

    // 审批意见确认
    // confirmReviewDialog() {
        // this.editFiles.price = this.priceSum
        // const newObj = this.editFiles
        // for (const key in newObj) {
        //     if (!this.editFileList.some(item => item.file === key)) {
        //         delete newObj[key]
        //     }
        // }
        // if(this.isRequired) {
        //     for(const key in newObj) {
        //         if(!newObj[key] || newObj[key].length === 0) {
        //             this.editFileRequired = true
        //             break;
        //         } else {
        //             this.editFileRequired = false
        //         }
        //     }
        // }
        // if(this.editFileRequired && this.approvalStatus === 1) {
        //     this.$message.error('请将编辑的信息填写完整')
        //     return
        // }
        // const obj = {
        //     messageReviewId: this.reviewId,
        //     status: this.approvalStatus,
        //     opinion: this.reviewIdea,
        //     form: this.approvalStatus ? newObj : {},
        //     nodeType: this.nodeType,
        //
        // }
        // this.disBtn = true;
        // const loading = Loading.service({
        //     text: `审批${this.approvalStatus === 1 ? '通过中' : '驳回中'}，请稍后`
        // })
        // setMessageReviewUserByMessageReviewId(obj).then(() => {
        //     this.$message.success(this.approvalStatus === 1 ? '审批通过' : '审批驳回')
        //     this.reviewIdea = ''
        //     this.reviewDialogShow = false
        //     loading.close();
        //     setTimeout(() => {
        //         window.close()
        //     }, 1500)
        // }).catch((err: Error) => {
        //     console.log(err)
        //     this.disBtn = false;
        //     loading.close();
        // })
    // }

    // approvedConfirm() {
    //     this.editFiles.price = this.priceSum
    //     const newObj = this.editFiles
    //     for (const key in newObj) {
    //         if (!this.editFileList.some(item => item.file === key)) {
    //             delete newObj[key]
    //         }
    //     }
    //     if(this.isRequired) {
    //         for(const key in newObj) {
    //             if(!newObj[key] || newObj[key].length === 0) {
    //                 this.editFileRequired = true
    //                 break;
    //             } else {
    //                 this.editFileRequired = false
    //             }
    //         }
    //     }
    //     if(this.editFileRequired && this.approvalStatus === 1) {
    //         this.$message.error('请将编辑的信息填写完整')
    //         return
    //     }
    //     const obj = {
    //         messageReviewId: this.reviewId,
    //         status: this.approvalStatus,
    //         opinion: this.reviewIdea,
    //         form: this.approvalStatus ? newObj : {},
    //         // nodeType: this.nodeType,
    //         isRevoke: this.isAgreeRevoke
    //     }
    //     this.disBtn = true;
    //     const loading = Loading.service({
    //         text: `审批${this.approvalStatus === 1 ? '通过中' : '驳回中'}，请稍后`
    //     })
    //     for(const key in obj) {
    //         if(obj[key].length === 0 || !obj[key]) {
    //             delete obj[key]
    //         }
    //     }
    //     setMessageReviewUserByMessageReviewId(obj).then(() => {
    //         this.$message.success(this.approvalStatus === 1 ? '审批通过' : '审批驳回')
    //         this.reviewIdea = ''
    //         this.reviewDialogShow = false
    //         loading.close();
    //         setTimeout(() => {
    //             window.close()
    //         }, 1500)
    //     }).catch((err: Error) => {
    //         console.log(err)
    //         this.disBtn = false;
    //         loading.close();
    //     })
    // }
//     关闭审批弹框
    handleApprovalClose() {
        this.approvalVisible = false
    }

//    驳回弹框确认
    doApprovalConfirm(data) {
        this.approvalVisible = false
    }

    // 审批通过弹框取消
    handleApprovedClose(){
        this.approvedVisible = false
    }
    // 审批通过弹框确认
    doApprovedConfirm(data) {
        this.approvedVisible = false
    }


    /*
    * 关闭转交弹框*/
    closeTransfer() {
        this.transferShow = false
    }

    /*
    * 转交弹框确认*/
    confirmTransfer() {
        this.transferShow = false
    }

    /*
    * 关闭加签*/
    closeAddSign() {
        this.addSignShow = false
    }

    /*
    * 确认加签*/
    confirmAddSign() {
        this.addSignShow = false
    }


    handleClickEgistrationForm() {
        this.downFile(this.infoData.egistrationForm,  this.infoData.customerName)
    }

    // 下载文件，自定义文件名称
    downFile(url, fileName) {
        const x = new XMLHttpRequest()
        x.open('GET', url, true)
        x.responseType = 'blob'
        x.onload = function() {
            const url = window.URL.createObjectURL(x.response)
            const a = document.createElement('a')
            a.href = url
            a.download = fileName
            a.click()
        }
        x.send()
    }
}
